export const AskForFiling = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
  >
    <g clipPath="url(#clip0_6446_5265)">
      <path
        d="M12.8008 8.00031V10.5003C12.8008 10.8981 12.6427 11.2797 12.3614 11.561C12.0801 11.8423 11.6986 12.0003 11.3008 12.0003H8.80078C8.09933 11.9996 7.4104 11.8144 6.80311 11.4634C6.19581 11.1124 5.69151 10.6078 5.34078 10.0003C5.71772 9.99761 6.09337 9.95606 6.46178 9.87631C6.74236 10.2271 7.09828 10.5103 7.50318 10.7049C7.90807 10.8995 8.35156 11.0004 8.80078 11.0003H11.3008C11.4334 11.0003 11.5606 10.9476 11.6543 10.8539C11.7481 10.7601 11.8008 10.6329 11.8008 10.5003V8.00031C11.8007 7.55093 11.6994 7.10734 11.5045 6.70243C11.3095 6.29752 11.026 5.94169 10.6748 5.66131C10.7552 5.29297 10.7974 4.91732 10.8008 4.54031C11.4083 4.89104 11.9128 5.39534 12.2639 6.00264C12.6149 6.60993 12.8001 7.29886 12.8008 8.00031ZM9.78928 4.82581C9.83604 4.18163 9.74359 3.53493 9.5182 2.92966C9.29282 2.32439 8.93977 1.77472 8.48307 1.31802C8.02637 0.861317 7.47671 0.508277 6.87143 0.282889C6.26616 0.0575015 5.61946 -0.0349522 4.97528 0.0118107C3.83374 0.142177 2.77924 0.685399 2.01037 1.53918C1.24149 2.39297 0.811295 3.4984 0.800781 4.64731L0.800781 7.16731C0.800781 8.43331 1.55428 9.00031 2.30078 9.00031H5.15078C6.30018 8.99042 7.40629 8.56051 8.26067 7.79159C9.11506 7.02266 9.65875 5.96782 9.78928 4.82581ZM7.77578 2.02581C8.13075 2.38156 8.40516 2.80941 8.58044 3.2804C8.75573 3.7514 8.8278 4.25455 8.79178 4.75581C8.68506 5.64765 8.25603 6.46972 7.58545 7.06728C6.91486 7.66484 6.04897 7.99667 5.15078 8.00031H2.30078C1.83678 8.00031 1.80078 7.36281 1.80078 7.16731V4.64731C1.80495 3.7495 2.13711 2.88416 2.73474 2.21415C3.33237 1.54414 4.15428 1.11564 5.04578 1.00931C5.12878 1.00331 5.21178 1.00031 5.29478 1.00031C5.75542 0.999882 6.21162 1.09023 6.63732 1.26619C7.06303 1.44215 7.44988 1.70027 7.77578 2.02581Z"
        fill="url(#paint0_linear_6446_5265)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6446_5265"
        x1="0.800781"
        y1="6.00016"
        x2="12.8008"
        y2="6.00016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <clipPath id="clip0_6446_5265">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0.800781)"
        />
      </clipPath>
    </defs>
  </svg>
);
